import { useTranslation } from 'react-i18next';
import type { AuditLogEntryResponse } from '../../api/generated';
import { formatDate } from '../../utils/dateUtils';
import styles from './AuditLog.module.css';

interface AuditLogProps {
  entries: AuditLogEntryResponse[];
}

export const AuditLog = ({ entries }: AuditLogProps) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{t('audit-log-title')}</h3>
      {entries.length === 0 ? (
        <p className={styles.empty}>{t('audit-log-empty')}</p>
      ) : entries.map((entry) => (
        <div key={`${entry.createdAt}-${entry.authorId}`} className={styles.row}>
          <span className={styles.message}>{entry.message}</span>
          <span className={styles.date}>{formatDate(entry.createdAt, i18n.language)}</span>
          <span className={styles.plan}>—</span>
          <span className={styles.author}>{entry.authorName}</span>
        </div>
      ))}
    </div>
  );
};
